import { reportLogQueueForPageHide } from '../report/reportLogQueueForPageHide';

type AddPageHideQueueObservationEventListener = () => void;
export const addPageHideQueueObservationEventListener: AddPageHideQueueObservationEventListener = () => {
  window.addEventListener('pagehide', reportLogQueueForPageHide);
};
